export default __webpack_public_path__ + "static/media/queryit_faq.9a47bff3.pdf";